import React from "react"

export default function Search({value, clearValue, placeholder, onChange}) {
    return (
        <div className="dropdown-with-search__search">
            <input type="text"
                className="dropdown-with-search__search-input"
                value={value}
                placeholder={placeholder}
                onChange={onChange} />
            <span className="dropdown-with-search__search-icon"/>
            {value && value !== "" &&
                <button
                    className="dropdown-with-search__search-clear-button"
                    onClick={clearValue}
                    onMouseDown={(e) => e.preventDefault()}>   
                </button>
            }
        </div>
    )
}